// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions-icon[data-v-762efe84]{padding-right:1rem;padding-left:0;margin-left:0}@media only screen and (min-width:1024px){.dropdown-trigger[data-v-762efe84]{display:none}}@media only screen and not (min-width:1024px){.actions-buttons[data-v-762efe84]{display:none}}.file-input[data-v-762efe84]{display:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
